export default function generateCSSRule(selector, cssDeclaration) {
  var support = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var cssRule = selector + '{' + cssDeclaration + '}';

  if (support.length > 0) {
    return '@supports ' + support + '{' + cssRule + '}';
  }

  return cssRule;
}